import React, { useState } from 'react';
import { utils } from '@ac/client';

interface CodeBlockProps {
  inline?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function CodeBlock({ inline, className, children, ...props }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);
  
  const match = /language-(\w+)/.exec(className || '');
  const language = match ? match[1] : '';
  const code = String(children).replace(/\n$/, '');

  const handleCopy = async () => {
    const success = await utils.copyToClipboard(code);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (inline) {
    return (
      <code className="px-1 py-0.5 bg-base-800 rounded text-sm" {...props}>
        {children}
      </code>
    );
  }

  return (
    <div className="relative group">
      <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition">
        <button
          onClick={handleCopy}
          className="px-2 py-1 bg-base-700 hover:bg-base-600 rounded text-xs transition"
          aria-label="Copy code"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      
      {language && (
        <div className="absolute top-2 left-2 text-xs text-base-500">
          {language}
        </div>
      )}
      
      <pre className="bg-base-800 rounded-lg p-4 overflow-x-auto">
        <code className={`text-sm ${className}`} {...props}>
          {children}
        </code>
      </pre>
    </div>
  );
}